
<template>
  <div id="App">
    <div
      v-if="!isSignInPage"
      class="inactivity-timer-overlay"
    >
      <!-- <InactivityTimer /> -->
    </div>

    <router-view></router-view>

    <pre-loading
      v-show="this.$store.state.preloader"
    ></pre-loading>
  </div>
</template>

<script>
import PreLoading from "./components/layouts/preloader";
import InactivityTimer from "./components/InactivityTimer.vue";

export default {
  name: "App",

  components: {
    PreLoading,
    InactivityTimer,
  },

  computed: {
    isSignInPage() {
      return this.$route.path === "/signin";
    },
  },
};
</script>

<style lang="scss">
@import "assets/scss/style";

.inactivity-timer-overlay {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
}
</style>
